import { Box, Skeleton, Typography, styled } from "@mui/material";

export interface TopbarTitleProps {
    ident: string;
    title: string;
    /** Si se proporciona, se muestra el logo en lugar de la píldora `ident`. */
    logoUrl?: string | null;
    /** Muestra un skeleton mientras se resuelve el logo. */
    logoLoading?: boolean;
}

const monoFontStack = "'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, monospace";

const Root = styled(Box, { shouldForwardProp: (prop) => prop !== "centered" })<{ centered?: boolean }>(
    ({ theme, centered }) => ({
        display: "flex",
        alignItems: centered ? "center" : "baseline",
        gap: theme.spacing(1.25),
        minWidth: 0,
    }),
);

const Ident = styled("span")(({ theme }) => ({
    fontFamily: monoFontStack,
    fontSize: "0.75rem",
    fontWeight: 700,
    color: theme.palette.secondary.main,
    backgroundColor: theme.palette.info.light,
    padding: "4px 10px",
    borderRadius: 999,
    letterSpacing: "0.02em",
    flexShrink: 0,
}));

const Dash = styled("span")(({ theme }) => ({
    color: theme.palette.text.disabled,
    fontWeight: 400,
}));

export const TopbarTitle = ({ ident, title, logoUrl, logoLoading = false }: TopbarTitleProps) => {
    const showLogo = logoLoading || Boolean(logoUrl);

    return (
        <Root centered={showLogo}>
            {logoLoading ? (
                <Skeleton variant="rectangular" width={90} height={24} sx={{ flexShrink: 0 }} />
            ) : logoUrl ? (
                <Box
                    component="img"
                    src={logoUrl}
                    alt={ident}
                    sx={{ height: 24, maxWidth: 110, objectFit: "contain", flexShrink: 0 }}
                />
            ) : (
                <Ident>{ident}</Ident>
            )}
            <Dash>·</Dash>
            <Typography
                variant="body1"
                sx={{
                    fontWeight: 600,
                    color: "text.primary",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                }}
            >
                {title}
            </Typography>
        </Root>
    );
};
